/**
 * Campaign visibility by ShowOnWebsite (Main vs Test) and deploy target.
 * GATSBY_IS_PRODUCTION_WEBSITE is set in gatsby-config.js from COMMON_ENV when unset.
 */

const SHOW_MAIN = 'Main (aatosklinikka.fi)';
const SHOW_TEST = 'Test (aatos-clinic-dev.taitodev.com)';

function isProductionWebsiteBuild() {
  return process.env.GATSBY_IS_PRODUCTION_WEBSITE === 'true';
}

/**
 * @param {string|null|undefined} showOnWebsite
 * @returns {typeof SHOW_MAIN | typeof SHOW_TEST}
 */
function normalizedShowOnWebsite(showOnWebsite) {
  if (showOnWebsite == null || showOnWebsite === '') return SHOW_TEST;

  if (showOnWebsite === SHOW_MAIN || showOnWebsite === SHOW_TEST) {
    return showOnWebsite;
  }

  // Legacy Yes / No
  if (showOnWebsite === 'Yes') return SHOW_MAIN;
  if (showOnWebsite === 'No' || showOnWebsite === 'None') return SHOW_TEST;

  // Legacy three-option enum
  if (showOnWebsite === 'Main website (https://www.aatosklinikka.fi/)') {
    return SHOW_MAIN;
  }
  if (
    showOnWebsite ===
    'Test website only (https://aatos-clinic-dev.taitodev.com/)'
  ) {
    return SHOW_TEST;
  }

  return SHOW_TEST;
}

/**
 * Whether to create /kampanja/[slug] in this Gatsby build (prod vs dev artifact).
 * @param {string|null|undefined} showOnWebsite
 */
function campaignShouldBuildPage(showOnWebsite) {
  const v = normalizedShowOnWebsite(showOnWebsite);
  if (v === SHOW_MAIN) return true;
  if (v === SHOW_TEST) return !isProductionWebsiteBuild();
  return !isProductionWebsiteBuild();
}

/**
 * Whether TopBannerVisibleOnOtherPages may appear on this site build (still require banner content in Strapi).
 * @param {string|null|undefined} showOnWebsite
 */
function campaignShouldShowTopBannerOnOtherPages(showOnWebsite) {
  const v = normalizedShowOnWebsite(showOnWebsite);
  if (isProductionWebsiteBuild()) {
    return v === SHOW_MAIN;
  }
  return v === SHOW_MAIN || v === SHOW_TEST;
}

module.exports = {
  SHOW_MAIN,
  SHOW_TEST,
  isProductionWebsiteBuild,
  normalizedShowOnWebsite,
  campaignShouldBuildPage,
  campaignShouldShowTopBannerOnOtherPages,
};
